 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React, {useEffect} from 'react'
import { usePreloadedQuery} from 'react-relay'
import DashModal from '../../../../components/Dashboard/DashModal'
import DialogContent from '../../../../components/DialogContent'
import DialogTitle from '../../../../components/DialogTitle'
import IconLabel from '../../../../components/IconLabel'
import PrimaryButton from '../../../../components/PrimaryButton'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useRouter from '../../../../hooks/useRouter'
import SendClientSideEvent from '../../../../utils/SendClientSideEvent'
import {PALETTE} from '../../../../styles/paletteV3'
import {ExternalLinks, Threshold} from '../../../../types/constEnums'



const StyledButton = styled(PrimaryButton)({
  margin: '1.5rem auto 0'
})

const LockedAtContent = styled(DialogContent)({
  textAlign: 'left',
  p: {
    marginBottom: 16
  }
})

const ContactUsLink = styled('a')({
  color: PALETTE.SKY_500,
  textDecoration: 'underline'
})





const query = graphql`
  query UnpaidTeamModalQuery($teamId: ID!) {
    viewer {
      team(teamId: $teamId) {
        lockMessageHTML
        organization {
          id
          lockedAt
          name
          billingLeaders {
            user {
              id
              preferredName
              email
            }
          }
          creditCard {
            brand
          }
          name
        }
        name
      }
    }
  }
`

const UnpaidTeamModal = (props) => {
  const {queryRef} = props
  const data = usePreloadedQuery(query, queryRef)
  const {viewer} = data
  const atmosphere = useAtmosphere()
  const {history} = useRouter()
  const {viewerId} = atmosphere
  const {team} = viewer

  useEffect(() => {
    if (_optionalChain([team, 'optionalAccess', _ => _.organization, 'access', _2 => _2.lockedAt])) {
      SendClientSideEvent(atmosphere, 'Upgrade CTA Viewed', {
        upgradeCTALocation: 'organizationLockedModal',
        orgId: team.organization.id
      })
    }
  }, [])

  if (!team) return null
  const {name: teamName, organization, lockMessageHTML} = team

  const {name: organizationName} = organization

  const {id: orgId, billingLeaders, name: orgName} = organization
  const [firstBillingLeader] = billingLeaders
  const {user: firstBillingLeaderUser} = _nullishCoalesce(firstBillingLeader, () => ( {}))
  const billingLeaderName = _nullishCoalesce(_optionalChain([firstBillingLeaderUser, 'optionalAccess', _3 => _3.preferredName]), () => ( 'Unknown'))
  const email = _nullishCoalesce(_optionalChain([firstBillingLeaderUser, 'optionalAccess', _4 => _4.email]), () => ( 'Unknown'))
  const isALeader = billingLeaders.findIndex((leader) => leader.user.id === viewerId) !== -1

  const goToBilling = (upgradeCTALocation) => {
    SendClientSideEvent(atmosphere, 'Upgrade CTA Clicked', {
      upgradeCTALocation
    })
    history.push(`/me/organizations/${orgId}`)
  }

  if (organization.lockedAt) {
    return (
      React.createElement(DashModal, null
        , React.createElement(DialogTitle, null, 'Organization Locked')
        , React.createElement(LockedAtContent, null
          , React.createElement('p', null, "Unfortunately, "
             , React.createElement('strong', null, organizationName), " has exceeded the"   , ' '
            , Threshold.MAX_STARTER_TIER_TEAMS, " teams limit on the Starter Plan for more than"         , ' '
            , Threshold.STARTER_TIER_LOCK_AFTER_DAYS, " days, and your account has been locked."
          )
          , isALeader ? (
            React.createElement(React.Fragment, null
              , React.createElement('p', null, "You can re-activate your teams by upgrading your account."        ), "If you’d like to keep using Parabol on the Starter Plan, please"
                         , ' '
              , React.createElement(ContactUsLink, { href: ExternalLinks.CONTACT, target: "_blank", rel: "noopener noreferrer" ,}, "contact us"

              ), ' ', "to let us know which teams you’d like to delete to fit within the two-team limit."

              , React.createElement(StyledButton, { size: "medium", onClick: () => goToBilling('organizationLockedModal'),}
                , React.createElement(IconLabel, { icon: "arrow_forward", iconAfter: true, label: "Upgrade",} )
              )
            )
          ) : (
            `Try reaching out to ${billingLeaderName} at ${email}`
          )
        )
      )
    )
  }

  if (lockMessageHTML) {
    return (
      React.createElement(DashModal, null
        , React.createElement('div', { dangerouslySetInnerHTML: {__html: lockMessageHTML},} )
      )
    )
  }

  const problem = `There in an unpaid invoice for ${teamName}.`
  const solution = isALeader
    ? `Head over to ${orgName} Settings to add a payment method`
    : `Try reaching out to ${billingLeaderName} at ${email}`
  return (
    React.createElement(DashModal, null
      , React.createElement(DialogTitle, null, 'Oh dear…')
      , React.createElement(DialogContent, null
        , problem
        , React.createElement('br', null )
        , solution
        , isALeader && (
          React.createElement(StyledButton, { size: "medium", onClick: () => goToBilling('unpaidTeamModal'),}
            , React.createElement(IconLabel, { icon: "arrow_forward", iconAfter: true, label: "Take me there"  ,} )
          )
        )
      )
    )
  )
}

export default UnpaidTeamModal
